{
 "_meta": {
  "locale": "de",
  "status": "partial",
  "note": "Shell translation (draft, needs native review). Missing keys fall back to English."
 },
 "nav": {
  "today": "Jetzt",
  "people": "Personen",
  "cases": "Vorgänge",
  "agenda": "Kalender",
  "reviews": "Überprüfungen",
  "prospects": "Akquise",
  "insights": "Einblicke",
  "data": "Daten & Sicherheit",
  "settings": "Einstellungen",
  "lens": "Lupe"
 },
 "common": {
  "save": "Speichern",
  "cancel": "Abbrechen",
  "close": "Schließen",
  "search": "Suchen",
  "today": "Heute",
  "tomorrow": "Morgen",
  "new": "Neu",
  "edit": "Bearbeiten",
  "delete": "Löschen"
 },
 "settings": {
  "title": "Einstellungen",
  "language": "Sprache",
  "region": "Markt / Region",
  "theme": "Darstellung"
 },
 "people": {
  "title": "Personen",
  "new": "Neue Person"
 },
 "today": {
  "agenda_title": "Heute"
 },
 "lens": {
  "placeholder": "Personen, Interessenten, Vorgänge suchen — oder Befehl eingeben"
 }
}